"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockCartUpsellProduct = void 0;
const product_1 = require("./product");
const product_family_1 = require("./product_family");
function mockCartUpsellProduct(overrides = {}) {
    return {
        confidence: 100,
        end_date: '2022-06-30T14:00:07.000Z',
        id: 1234567,
        item_in_cart: (0, product_family_1.mockProductFamily)(),
        item_to_recommend: (0, product_1.mockProduct)(),
        start_date: '2022-06-28T14:00:05.000Z',
        ...overrides,
    };
}
exports.mockCartUpsellProduct = mockCartUpsellProduct;
